/* tslint:disable */
/* eslint-disable */
/* @relayHash c0bdae3310003cadbe4eaf0dee58354c */

import { ConcreteRequest } from "relay-runtime";
export type ACCOUNT_TYPE = "STUDENT" | "TEACHER" | "%future added value";
export type EmailSignupInput = {
    username: string;
    email: string;
    accountType?: ACCOUNT_TYPE | null;
    password: string;
    clientMutationId?: string | null;
};
export type EmailSignupMutationVariables = {
    input: EmailSignupInput;
};
export type EmailSignupMutationResponse = {
    readonly emailSignup: {
        readonly user: {
            readonly id: string;
        } | null;
        readonly token: string | null;
    } | null;
};
export type EmailSignupMutation = {
    readonly response: EmailSignupMutationResponse;
    readonly variables: EmailSignupMutationVariables;
};



/*
mutation EmailSignupMutation(
  $input: EmailSignupInput!
) {
  emailSignup(input: $input) {
    user {
      id
    }
    token
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "EmailSignupInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "emailSignup",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EmailSignupPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "token",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "EmailSignupMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "EmailSignupMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "EmailSignupMutation",
    "id": null,
    "text": "mutation EmailSignupMutation(\n  $input: EmailSignupInput!\n) {\n  emailSignup(input: $input) {\n    user {\n      id\n    }\n    token\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = 'd48aae0b5a1c7ed58f1d8aad1db181ff';
export default node;
